var exports = {
  "k": "xa15a2ab7--e5484e--container",
};

module.exports = exports;
